const config = {
  prefix: "TIM",
  accessToken: "AccessToken",
  refreshToken: "RefreshToken",
} as const;

/**
 * Saving data to localStorage.
 */
export const saveLocalStorage = (name: string, value: unknown) => {
  if (typeof window === "undefined" ?? !window.localStorage) return;
  localStorage.setItem(`${config.prefix}:${name}`, JSON.stringify(value));
};

/**
 * Load data from localStorage.
 */
export const loadLocalStorage = (name: string) => {
  if (typeof window === "undefined" ?? !window.localStorage) return null;
  const serialized = localStorage.getItem(`${config.prefix}:${name}`);
  if (serialized === null) return null;
  return JSON.parse(serialized) as string;
};

/**
 * Remove data from localStorage.
 */
export const removeLocalStorage = (name: string) => {
  if (typeof window === "undefined" ?? !window.localStorage) return;
  localStorage.removeItem(`${config.prefix}:${name}`);
};

/**
 * Saving data to sessionStorage.
 */
export const saveSessionStorage = (name: string, value: unknown) => {
  if (typeof window === "undefined" ?? !window.sessionStorage) return;
  sessionStorage.setItem(`${config.prefix}:${name}`, JSON.stringify(value));
};

/**
 * Load data from sessionStorage.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const loadSessionStorage = (name: string): any => {
  if (typeof window === "undefined" ?? !window.sessionStorage) return null;
  const serialized = sessionStorage.getItem(`${config.prefix}:${name}`);
  if (serialized === null) return null;
  return JSON.parse(serialized);
};

/**
 * Remove data from sessionStorage.
 */
export const removeSessionStorage = (name: string) => {
  if (typeof window === "undefined" ?? !window.sessionStorage) return;
  sessionStorage.removeItem(`${config.prefix}:${name}`);
};

export const saveAccessToken = (accessToken: string) =>
  saveLocalStorage(config.accessToken, accessToken);
export const loadAccessToken = () => loadLocalStorage(config.accessToken);
export const clearAccessToken = () => removeLocalStorage(config.accessToken);

export const saveRefreshToken = (refeshToken: string) =>
  saveLocalStorage(config.refreshToken, refeshToken);
export const loadRefreshToken = () => loadLocalStorage(config.refreshToken);
export const clearRefreshToken = () => removeLocalStorage(config.refreshToken);

const storagePrefix = "client_portal_user_";

const storage = {
  getToken: () => {
    return window.localStorage.getItem(`${storagePrefix}token`) as string;
  },
  getRefreshToken: () => {
    return window.localStorage.getItem(
      `${storagePrefix}refresh-token`
    ) as string;
  },
  setToken: (token: string) => {
    // console.log('setToken: ..................', token)
    window.localStorage.setItem(`${storagePrefix}token`, token);
  },
  setRefreshToken: (token: string) => {
    window.localStorage.setItem(`${storagePrefix}refresh-token`, token);
  },
  clearToken: () => {
    window.localStorage.removeItem(`${storagePrefix}token`);
    window.localStorage.removeItem(`${storagePrefix}refresh-token`);
    window.localStorage.removeItem(`${storagePrefix}permissions`);
  },
  getPermissions: () => {
    const permissionsStorage = window.localStorage.getItem(
      `${storagePrefix}permissions`
    ) as string;
    return JSON.parse(permissionsStorage) as string[];
  },
  setPermissions: (permissions: string[]) => {
    window.localStorage.setItem(
      `${storagePrefix}permissions`,
      JSON.stringify(permissions)
    );
  },
  getPermissionsMenu: () => {
    const permissionsStorageMenu = window.localStorage.getItem(
      `${storagePrefix}permissionsMenu`
    ) as string;
    return JSON.parse(permissionsStorageMenu) as string[];
  },
  setPermissionsMenu: (permissionsMenu: string[]) => {
    window.localStorage.setItem(
      `${storagePrefix}permissionsMenu`,
      JSON.stringify(permissionsMenu)
    );
  },
  getRebuildOnce: () => {
    return JSON.parse(
      `${window.localStorage.getItem(`${storagePrefix}rebuild`) as string}`
    ) as string;
  },
  setRebuildOnce: (isRebuildAlready: boolean) => {
    window.localStorage.setItem(
      `${storagePrefix}rebuild`,
      String(isRebuildAlready)
    );
  },
  clearPermissions: () => {
    window.localStorage.removeItem(`${storagePrefix}permissions`);
  },
};

export default storage;
